
import {
  Component, OnInit, OnDestroy,
} from '@angular/core';
import { BulletinBoardService } from 'src/app/services/bulletin-board.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-view-post',
  templateUrl: './view-post.component.html',
  styleUrls: [ './view-post.component.scss' ],
})
export class ViewPostComponent implements OnInit, OnDestroy {
  isLoading = true;
  post: {
    title: '',
    content: '',
    publishedDate: '',
    publishedBy: '',
  };
  postsData$ = this.bulletinBoardService.postsData$;
  postsSubscription = this.postsData$.subscribe((data) => {
    this.isLoading = false;
    if (!data) {
      return;
    }

    this.post = data;
  });
  permissions: any;
  permissionsSubscription: any;

  constructor(
    private bulletinBoardService: BulletinBoardService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.searchForPost();
    this.permissionsSubscription = this.auth.permissions$.subscribe((permissions: any) => {
      this.permissions = permissions;
    });
  }

  searchForPost() {
    this.isLoading = true;
    this.bulletinBoardService.getPost(this?.route?.snapshot?.params['id'])
  }

  formatDate = (date) => {
    const dt = new Date(date)
    const month = dt.getMonth() + 1
    const day = dt.getDate()
    const year = dt.getFullYear().toString().slice(2, 4)
    return month < 10 ? `0${month}/${day}/${year}` : `${month}/${day}/${year}`
  }

  formatTime = (publishedDate) => {
    const date = new Date(publishedDate)
    let hours = date.getHours();
    let minutes = date.getMinutes().toString();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes.padStart(2, '0')
    const time = hours + ':' + minutes + ' ' + ampm;
    return time
  }

  getPostTime = () => {
    return `${this.formatDate(this.post?.publishedDate)}, ${this.formatTime(this.post?.publishedDate)}`
  }

  goBack = () => {
    this.router.navigate([ '/bulletin-board' ])
  }

  editPost = () => {
    this.router.navigate([ '/bulletin-board/' + this?.route?.snapshot?.params['id'] + '/edit' ])
  }

  deletePost = () => {
    const id = Number(this?.route?.snapshot?.params['id']);

    this.bulletinBoardService.deletePost(id).subscribe({
      next: () => {
        this.toastService.setToast({
          text: 'Post deleted successfully',
          type: 'success',
        })
        this.router.navigate([ '/bulletin-board' ])
      },
      error: (error) => {
        this.toastService.setToast({
          text: error.error.message,
          type: 'error',
        })
      },
    })
  }

  ngOnDestroy() {
    this.postsSubscription.unsubscribe();
  }

}
